import React, { useContext, useEffect, useState } from "react";


import separatorLine from "../../images/separatorLine.svg"
import APointIco from "../../images/APointIco.svg"
import BPointIco from "../../images/BPointIco.svg"

import searchIco from "../../images/app_bar.png"

import * as gruzovikiApi from "../../utils/api.js"
// import { citiesIds } from "../../utils/services.js";
import {getCityId} from "../../utils/api.js"
import {useNavigate} from "react-router-dom";


function FilterPopup() {

    const navigate = useNavigate();

    const token = localStorage.getItem("token")
    const tg = window.Telegram?.WebApp;
    tg.expand()

    const [userId, setUserId] = useState(null);
    const [userCity, setUserCity] = useState("");

    useEffect(() => {

        let user_id
        let fromUrl = false;

        // Если доступен tg.initDataUnsafe
        if (tg?.initDataUnsafe?.user) {
            user_id = tg.initDataUnsafe.user.id;
        } else {
            // Если нужно извлечь из URL
            const params = new URLSearchParams(window.location.search);
            const idFromUrl = Number(params.get('userId'));
            user_id = idFromUrl
             if (Number.isFinite(idFromUrl) && idFromUrl > 0) {
                user_id = idFromUrl;
                fromUrl = true;
             }

        }

        setUserId(user_id);

        if (fromUrl) {
            navigate(`/filterNew?userId=${user_id}`, { replace: true });
        } else {
            navigate("/filterNew", { replace: true });
        }

        
        gruzovikiApi.getUserType(user_id, token)
            .then((userType) => {
                // if (userType === 0) {
                    // console.error("Доступ запрещен.");
                    // Закрытие приложения
                    // tg.close();
                    // alert(1)
                // } else if (userType === 2) {
                const excludedUserIds = [837143843, 5267329136, 425169377];
                if (user_id && userType === 2 && !excludedUserIds.includes(user_id)) {
                    console.log(user_id)
                    // Переадресация
                    // window.location.href = 'https://cargo.gruz.app';
                }
                // Если userType = 1, ничего не делаем и продолжаем выполнение
            })
            .catch((err) => {
                console.error("Ошибка получения типа пользователя:", err);
            });
    }, []);

    console.log(userId)

    let todayDate = new Date()
    let tomorrowDate = new Date()
    tomorrowDate.setDate(todayDate.getDate() + 1)
    let afterTomorrowDate = new Date()
    afterTomorrowDate.setDate(todayDate.getDate() + 2)
    // let yesterdayDate = new Date()
    // yesterdayDate.setDate(todayDate.getDate() - 1)

    let searchType = 'city'
    let type_city = 'city'
    let type_intercity = 'intercity'

    const opened = true
    const [filtersArray, setFiltersArray] = useState({
        searchType: searchType,
        cities: [],
        dates: [todayDate, tomorrowDate],
        dateChoose: 'tomorrow',
        radiusA: 0,
        radiusB: 0,
        anywhereA: false,
        anywhereB: false,
        useMyCityA: false,
        useMyCityB: false,
        findReturn: false
    })

    
      const [citiesArray, setCitiesArray] = useState([
        {
            cityId: 1,
            name: '',
            error: false
        },
        {
            cityId: 2,
            name: '',
            error: false
        }
    ])
    const [filteredCities, setFilteredCities] = useState([]); // Фильтрованные города
    const [showDropdown, setShowDropdown] = useState(0); // Показывать ли выпадающий список



    useEffect(() => {
        gruzovikiApi.getUserFilters(userId, token)
            .then((data) => {
                if (data) {
                    let fromDate
                    let toDate
                    switch (data.dateChoose) {
                        case ('today'):
                            fromDate = todayDate
                            toDate = todayDate
                            break;
                        case ('tomorrow'):
                            fromDate = todayDate
                            toDate = tomorrowDate
                            break;
                        case ('next'):
                            fromDate = todayDate
                            toDate = afterTomorrowDate
                            break;
                        case ('from-today'):
                            fromDate = todayDate
                            toDate = null
                            break;
                        case ('from-tomorrow'):
                            fromDate = tomorrowDate
                            toDate = null
                            break;
                        default: // Этот блок выполняется, если ни одно условие не совпало
                            fromDate = todayDate
                            toDate = tomorrowDate
                            break;
                    }

                    // Если данные есть, устанавливаем их в filtersArray
                    setCitiesArray((prev) => [
                        { cityId: 1, name: data.from_city || '', error: false },
                        { cityId: 2, name: data.to_city || '', error: false }
                    ]);
                    setFiltersArray((prev) => ({
                        ...prev,
                        searchType: data.searchType || 'intercity',
                        radiusA: data.radius_from_city || 0,
                        radiusB: data.radius_to_city || 0,
                        anywhereA: data.anywhereA || false,
                        anywhereB: data.anywhereB || false,
                        useMyCityA: data.useMyCityA || false,
                        useMyCityB: data.useMyCityB || false,
                        findReturn: data.findReturn || false,
                        dates: [fromDate, toDate],
                        dateChoose: data.dateChoose || 'tomorrow'
                    }));
                }
            })
            .catch((err) => {
                console.error("Ошибка получения фильтров:", err);
            });

        gruzovikiApi.getUserCity(userId, token)
        .then((data) => {
            if (data) {
                setUserCity(data);
            }
        })
        .catch((err) => {
            console.error("Ошибка получения фильтров:", err);
        });


    }, [userId]);

    const handleInputChange = (e) => {
        const { name, value, type, checked, id } = e.target;
        if (type === "checkbox") {
            setFiltersArray((prevInputs) => {
                // const updatedVehicleType = checked
                    // ? [...prevInputs.vehicleType, value]
                    // : prevInputs.vehicleType.filter((type) => type !== value);
                // return { ...prevInputs, vehicleType: updatedVehicleType };
                return { ...prevInputs};
            });
        } else {
            setFiltersArray((prevInputs) => {
                let updatedValue;
                switch (type) {
                    case 'number':
                        updatedValue = value ? Number(value) : 0;
                        break;
                    case 'date':
                        updatedValue = value ? new Date(value) : 0;
                        break;
                    default:
                        updatedValue = value || 0;
                        break;
                }

                if (id === "from") {
                    // Устанавливаем значение в нулевой индекс массива
                    return {
                        ...prevInputs,
                        [name]: [updatedValue, ...(prevInputs[name].slice(1) || [0, 0])]
                    };
                } else if (id === "to") {
                    // Устанавливаем значение в первый индекс массива
                    return {
                        ...prevInputs,
                        [name]: [(prevInputs[name][0] !== undefined ? prevInputs[name][0] : 0), updatedValue, ...(prevInputs[name].slice(2) || [0, 0])]
                    };
                } else {
                    // Для других случаев
                    return { ...prevInputs, [name]: updatedValue };
                }
            });
        }
    };

    const handleReset = () => {
        setCitiesArray([{
            cityId: 1,
            name: ''
        },
        {
            cityId: 2,
            name: ''
        }
        ])
        setFiltersArray({
            searchType: 'city',
            cities: [],
            dates: [todayDate, tomorrowDate],
            dateChoose: 'tomorrow',
            radiusA: 0,
            radiusB: 0
        })
    };

    console.log(citiesArray)

    // const handleSubmit = async () => {
    //     const results = await Promise.all(
    //         citiesArray.map(async (city, index) => {
    //
    //           // Если anywhereA или anywhereB — пропускаем проверку
    //           if ((index === 0 && filtersArray.anywhereA) || (index === 1 && filtersArray.anywhereB)) {
    //             return true; // любое число > 0, чтобы считался валидным
    //           }
    //
    //           const trimmedName = city.name.trim();
    //
    //           // Для реального города вызываем getCityId
    //           const cityId = await getCityId(trimmedName);
    //           return { trimmedName, cityId };
    //         })
    //       );
    //
    //       // 2. Проверяем корректность всех городов:
    //       const isValid = results.every(({ trimmedName, cityId }) => {
    //         // Валидно, если trimmedName не пустой и cityId не 0
    //         console.log(cityId)
    //         return trimmedName !== '' && cityId !== 0;
    //       });
    //
    //     // 3. Формируем updatedCitiesArray, используя уже полученные результаты
    //     const updatedCitiesArray = results.map(({ trimmedName, cityId }, index) => ({
    //         ...citiesArray[index],
    //         name: trimmedName,
    //         error: trimmedName === '' || cityId === 0,
    //     }));
    //
    //     // 4. Обновляем стейт
    //     setCitiesArray(updatedCitiesArray);
    //
    //
    //     if (!isValid) {
    //         console.log('no')
    //         return; // Если данные некорректны, прекращаем выполнение
    //     }
    //
    //     // Формируем массив городов для отправки
    //     const submitCitiesArray = updatedCitiesArray
    //
    //         .map(city => city.name);
    //
    //     // Обновляем filtersArray
    //     setFiltersArray((prevInputs) => ({
    //         ...prevInputs,
    //         cities: submitCitiesArray,
    //     }));
    //
    //     // Отправляем запрос
    //     gruzovikiApi
    //         .searchOrders({ ...filtersArray, cities: submitCitiesArray }, userId)
    //         .then(res => {
    //             console.log(res);
    //         })
    //         .catch(err => {
    //             console.error(err);
    //         });
    //
    //     // Задержка перед закрытием tg
    //     setTimeout(() => {
    //         tg.close();
    //     }, 500); // Задержка в 500 миллисекунд
    //
    //
    // }
const handleSubmit = async () => {
  const activeIdx = filtersArray.searchType === 'city' ? [0] : [0, 1];

  const results = await Promise.all(
    activeIdx.map(async (idx) => {
      const city = citiesArray[idx];
      const anywhere = idx === 0 ? filtersArray.anywhereA : filtersArray.anywhereB;
      if (anywhere) return { idx, ok: true, trimmedName: "", cityId: null };

      const trimmedName = city.name.trim();
      if (!trimmedName) return { idx, ok: false, trimmedName, cityId: 0 };

      const cityId = await getCityId(trimmedName);
      return { idx, ok: cityId !== 0, trimmedName, cityId };
    })
  );

  const updatedCitiesArray = citiesArray.map((c, idx) => {
    const res = results.find(r => r.idx === idx);
    return res ? { ...c, name: res.trimmedName || c.name, error: !res.ok } : { ...c, error: false };
  });
  setCitiesArray(updatedCitiesArray);

  if (!results.every(r => r.ok)) return;

  // ⭐ для city отправляем [A, A]; для intercity — [A, B]
  const first = updatedCitiesArray[0].name;
  const submitCitiesArray = filtersArray.searchType === 'city'
    ? [first, first]
    : [updatedCitiesArray[0].name, updatedCitiesArray[1].name].filter(Boolean);

  const payload = { ...filtersArray, cities: submitCitiesArray };
  setFiltersArray(prev => ({ ...prev, cities: submitCitiesArray }));

  gruzovikiApi.searchOrders(payload, userId)
    .then(res => console.log(res))
    .catch(err => console.error(err));

  setTimeout(() => tg.close(), 500);
};


    const handleDateCheckboxClick = (e) => {
        const { id } = e.target
        let fromDate
        let toDate
        switch (id) {
            case ('today'):
                fromDate = todayDate
                toDate = todayDate
                break;
            case ('tomorrow'):
                fromDate = todayDate
                toDate = tomorrowDate
                break;
            case ('next'):
                fromDate = todayDate
                toDate = afterTomorrowDate
                break;
            case ('from-today'):
                fromDate = todayDate
                toDate = null
                break;
            case ('from-tomorrow'):
                fromDate = tomorrowDate
                toDate = null
                break;

        }
        setFiltersArray((prevInputs) => ({ ...prevInputs, dates: [fromDate, toDate], dateChoose: id }));
    }


    const handleTypeCheckboxClick = (e) => {
        const { id } = e.target

        setFiltersArray((prevInputs) => ({ ...prevInputs, searchType: id}));

    }

    const handleCityNameChange = (e, cityId) => {
        const newName = e.target.value;

        let anywherename
        let useMyCityName

        if (cityId === 1 ) {
            anywherename = 'anywhereA'
            useMyCityName = 'useMyCityA'
        } else if (cityId === 2 ) {
            anywherename = 'anywhereB'
            useMyCityName = 'useMyCityB'
        }


        // Обновляем только тот объект, у которого cityId совпадает
        const updatedCitiesArray = citiesArray.map((city) =>
            city.cityId === cityId ? { ...city, name: newName } : city
        );
        setCitiesArray(updatedCitiesArray);

        // Фильтрация городов
        if (newName.trim() === '') {
            setFilteredCities([]);
            setShowDropdown(0);
        } else {
            // const filtered = Object.keys(citiesIds).filter((city) =>
            //     city.toLowerCase().startsWith(newName.toLowerCase()) // Проверяем только начало строки
            // );
            // setFilteredCities(filtered);
            // setShowDropdown(cityId);
            
            gruzovikiApi.filterCities(newName)
                .then((data) => {
                    setFilteredCities(data);
                    setShowDropdown(cityId);
                })
                .catch((err) => {
                    console.error('Ошибка при фильтрации городов:', err);
                });

        }

        let submitCitiesArray = updatedCitiesArray.filter(city => city.name !== '').map(city => city.name)
        setFiltersArray((prevInputs) => {
            return { ...prevInputs, cities: submitCitiesArray, [anywherename]: false, [useMyCityName]: false};
        });
    };

    
    const handleCitySelect = (newCity, cityId) => {
        // Обновляем только тот объект, у которого cityId совпадает
        const updatedCitiesArray = citiesArray.map((city) =>
            city.cityId === cityId ? { ...city, name: newCity } : city
        );
        setCitiesArray(updatedCitiesArray);

        // Закрываем выпадающий список
        setShowDropdown(0);
        setFilteredCities([]);
    };


    // Обработчик изменения состояния чекбокса Мой город
    const handleCheckboxMyCityChange = (e, cityId) => {
        let newName
        let anywherename
        let useMyCityName
        if (e.target.checked) {
            newName = userCity;
        } else {
            newName = "";
        }

        if (cityId === 1 && e.target.checked === true) {
            anywherename = 'anywhereA'
        } else if (cityId === 2 && e.target.checked === true) {
            anywherename = 'anywhereB'
        }

        if (cityId === 1 ) {
            useMyCityName = 'useMyCityA'
        } else if (cityId === 2 ) {
            useMyCityName = 'useMyCityB'
        }

        // Обновляем только тот объект, у которого cityId совпадает
        const updatedCitiesArray = citiesArray.map((city) =>
            city.cityId === cityId ? { ...city, name: newName, error: false } : city
        );
        setCitiesArray(updatedCitiesArray);

        setFiltersArray((prevInputs) => {
            return { ...prevInputs, [anywherename]: false, [useMyCityName]: e.target.checked};
        });
    };

    // Обработчик изменения состояния откуда-куда угодно
    const handleCheckboxAnywhereChange = (e) => {
        const { name, checked } = e.target;

        let checkCityId
        let useMyCityName
        if (name === 'anywhereA') {
            checkCityId = 1
        } else {
            checkCityId = 2
        }

        if (checkCityId === 1 && e.target.checked === true) {
            useMyCityName = 'useMyCityA'
        } else if (checkCityId === 2 && e.target.checked === true) {
            useMyCityName = 'useMyCityB'
        }

        const updatedCitiesArray = citiesArray.map((city) =>
            city.cityId === checkCityId ? { ...city, name: '', error: false} : city
        );
        setCitiesArray(updatedCitiesArray);

        setFiltersArray((prevInputs) => {
            return { ...prevInputs, [name]: e.target.checked, [useMyCityName]: false};
        });

        console.log(name, checked)

    };

    // Обработчик поиска обратки
    const handleCheckboxFindReturnChange = (e) => {
        const { name, checked } = e.target;

        setFiltersArray((prevInputs) => {
            return { ...prevInputs, [name]: e.target.checked};
        });

        console.log(name, checked)

    };

    const handleClearCityName = (e, cityId) => {
        const newName = '';

        let useMyCityName

        if (cityId === 1 ) {
            useMyCityName = 'useMyCityA'
        } else if (cityId === 2 ) {
            useMyCityName = 'useMyCityB'
        }

        // Обновляем только тот объект, у которого cityId совпадает
        const updatedCitiesArray = citiesArray.map((city) =>
            city.cityId === cityId ? { ...city, name: newName } : city
        );
        setCitiesArray(updatedCitiesArray);

        setShowDropdown(0);
        setFilteredCities([]);

        setFiltersArray((prevInputs) => {
            return { ...prevInputs, [useMyCityName]: false};
        });

    };

    console.log(filtersArray)

    return (
        <div className={opened ? "filter-container" : "filter-container filter-container_closed"}>

            <div className="filter-popup__grabber" />
            {
                opened ?
                    <div className="filter-popup_categories">
                        {/* <img src={truckIco} alt="" className="filter-popup__start-img-1" /> */}
                        {/*<img src={searchIco} alt="" className="filter-popup__start-img" />*/}

                        <div className="filter-popup__cities filter-popup__category-container">

                            {
                                filtersArray.searchType === 'intercity' ?
                                    <span className="filter-popup__toggle-label-searchType">Фильтр по межгороду</span>

                                    :
                                    <span className="filter-popup__toggle-label-searchType">Фильтр по городу</span>

                            }

                            <div className="filter-popup__searchType-checkbox-container">
                                <div className="filter-popup__row">
                                    <div
                                        className="filter-popup__check-button-container filter-popup_check-search_type">
                                        <input type="radio" name="searchType" id="city" value={type_city}
                                               className="filter-popup__check-button" onChange={handleTypeCheckboxClick}
                                               checked={filtersArray.searchType === 'city' ? true : false}/>
                                        <label htmlFor="city"
                                               className="filter-popup_search_type_check-button-label">Город</label>
                                    </div>
                                    <div
                                        className="filter-popup__check-button-container filter-popup_check-search_type">
                                        <input type="radio" name="searchType" id="intercity" value={type_intercity}
                                               className="filter-popup__check-button" onChange={handleTypeCheckboxClick}
                                               checked={filtersArray.searchType === 'intercity' ? true : false}/>
                                        <label htmlFor="intercity"
                                               className="filter-popup_search_type_check-button-label">Межгород</label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={`filter-popup__cities filter-popup__category-container ${
                                 filtersArray.searchType === 'intercity' ? 'two_cities' : ''
                             }`}
                        >
                            {/* <div className="filter-popup__show-filter-button filter-popup__category-button">
                                Направление
                            </div> */}


                            {
                                filtersArray.searchType === 'intercity' ?
                                <svg className="stepper_icon" width="20" height="100" viewBox="0 0 20 100" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <line x1="9.5" y1="17" x2="9.5" y2="62" stroke="#FF5F4F"/>
                                    <circle cx="10" cy="10" r="7" stroke="#FF5F4F" stroke-width="6"/>
                                    <circle cx="9.5" cy="69.5" r="7.75" stroke="#FF5F4F" stroke-width="1.5"/>
                                    <circle cx="9.49926" cy="69.4993" r="4.45238" fill="#FF5F4F"/>
                                </svg>
                                :<></>
                            }


                            <div className="filter-popup__container">
                                {/*<div className="filter-popup__top-row">*/}
                                {/*    <div className="filter-popup__from-block">*/}
                                {/*        {*/}
                                {/*        filtersArray.searchType === 'city' ?*/}
                                {/*        <span className="filter-popup__label">Ваш город</span>*/}
                                {/*        :*/}
                                {/*        <span className="filter-popup__label">Откуда</span>*/}
                                {/*        }*/}
                                {/*    </div>*/}
                                {/*    */}
                                {/*</div>*/}


                                <div className="filter-popup__bottom-row">
                                    <div className="filter-popup__input-wrapper">
                                        <input
                                            type="text"
                                            placeholder={`${
                                                filtersArray.searchType === 'intercity'
                                                    ? filtersArray.anywhereA ? 'Откуда угодно' : 'Откуда'
                                                    :
                                                    filtersArray.anywhereA ? 'Откуда угодно' : 'Введите город развоза'

                                            }`}

                                            className={`filter-popup__input ${citiesArray[0].error ? 'input-error' : ''}`}
                                            name="startCity" id="adress-a"
                                            value={citiesArray[0].name}
                                            onChange={(e) => handleCityNameChange(e, 1)}
                                            onFocus={() => setShowDropdown(1)} // Показываем список при фокусе
                                            onBlur={() => setTimeout(() => setShowDropdown(0), 100)} // Скрываем список с задержкой
                                        />

                                        {
                                            citiesArray[0].name ?
                                                <button
                                                    type="button"
                                                    className="filter-popup__clear-button"
                                                    onClick={(e) => handleClearCityName(e, 1)}
                                                >
                                                    ×
                                                </button>
                                                : <svg xmlns="http://www.w3.org/2000/svg" width="16" height="22"
                                                       viewBox="0 0 16 22" fill="none">
                                                    <path
                                                        d="M7.99997 0C3.58883 0 0 3.7969 0 8.46384C0 12.8751 6.64016 20.4697 7.3972 21.3221L7.99997 22L8.60274 21.3221C9.35996 20.4704 16 12.8751 16 8.46384C16.0003 3.7969 12.4115 0 7.99997 0ZM7.99997 11.9664C6.17473 11.9664 4.68962 10.3952 4.68962 8.46414C4.68962 6.53302 6.17473 4.96187 7.99997 4.96187C9.82561 4.96187 11.3103 6.53308 11.3103 8.46414C11.3103 10.3953 9.82561 11.9664 7.99997 11.9664Z"
                                                        fill="#d5d5d5"/>
                                                </svg>
                                        }

                                        {showDropdown === 1 && filteredCities.length > 0 && (
                                            <ul className="filter-popup__dropdown">
                                                {filteredCities.map((city) => (
                                                    <li
                                                        key={city}
                                                        className="filter-popup__dropdown-item"
                                                        onClick={() => handleCitySelect(city, 1)}
                                                    >
                                                        {city}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}

                                    </div>
                                </div>

                            </div>

                            {
                                filtersArray.searchType === 'intercity' ?
                                    <div className="filter-popup__container">
                                        {/*<div className="filter-popup__top-row">*/}
                                        {/*    <div className="filter-popup__from-block">*/}
                                        {/*        <span className="filter-popup__label">Куда</span>*/}
                                        {/*    </div>*/}

                                        {/*</div>*/}
                                        <div className="filter-popup__bottom-row">
                                            <div className="filter-popup__input-wrapper">
                                                <input
                                                    type="text"
                                                    placeholder={`${filtersArray.anywhereB ? 'Куда угодно' : 'Куда'}`}
                                                    className={`filter-popup__input ${citiesArray[1].error ? 'input-error' : ''}`}
                                                    name="endCity" id="adress-b"
                                                    value={citiesArray[1].name}
                                                    onChange={(e) => handleCityNameChange(e, 2)}
                                                    onFocus={() => setShowDropdown(2)} // Показываем список при фокусе
                                                    onBlur={() => setTimeout(() => setShowDropdown(0), 100)} // Скрываем список с задержкой
                                                />


                                                {
                                                    citiesArray[1].name ?
                                                        <button
                                                            type="button"
                                                            className="filter-popup__clear-button"
                                                            onClick={(e) => handleClearCityName(e, 2)}
                                                        >
                                                            ×
                                                        </button>
                                                        : <svg xmlns="http://www.w3.org/2000/svg" width="16" height="22"
                                                               viewBox="0 0 16 22" fill="none">
                                                            <path
                                                                d="M7.99997 0C3.58883 0 0 3.7969 0 8.46384C0 12.8751 6.64016 20.4697 7.3972 21.3221L7.99997 22L8.60274 21.3221C9.35996 20.4704 16 12.8751 16 8.46384C16.0003 3.7969 12.4115 0 7.99997 0ZM7.99997 11.9664C6.17473 11.9664 4.68962 10.3952 4.68962 8.46414C4.68962 6.53302 6.17473 4.96187 7.99997 4.96187C9.82561 4.96187 11.3103 6.53308 11.3103 8.46414C11.3103 10.3953 9.82561 11.9664 7.99997 11.9664Z"
                                                                fill="#d5d5d5"/>
                                                        </svg>
                                                }


                                                {showDropdown === 2 && filteredCities.length > 0 && (
                                                    <ul className="filter-popup__dropdown">
                                                        {filteredCities.map((city) => (
                                                            <li
                                                                key={city}
                                                                className="filter-popup__dropdown-item"
                                                                onClick={() => handleCitySelect(city, 2)}
                                                            >
                                                                {city}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                )}


                                            </div>

                                        </div>


                                    </div>
                                    :
                                    <></>
                            }

                        </div>


                        {
                            filtersArray.searchType === 'intercity' ?
                                <div className="filter-popup__toggle-block toggle-anywhere">
                                    <span className="filter-popup__toggle-label">Куда угодно</span>
                                    <label className="filter-popup__slider-container">
                                        <input name="anywhereB" type="checkbox" className="filter-popup__checkbox"
                                               checked={filtersArray.anywhereB}
                                               onChange={(e) => handleCheckboxAnywhereChange(e)}/>
                                        <span className="filter-popup__slider"></span>
                                    </label>
                                </div> :
                                <></>

                        }

                        {
                            filtersArray.searchType === 'intercity' ?
                                <div className="filter-popup__toggle-block toggle-findReturn">
                                    <span className="filter-popup__label filter-popup__toggle-label-findReturn">Искать обратку</span>
                                    <label className="filter-popup__slider-container">
                                        <input name="findReturn" type="checkbox" className="filter-popup__checkbox"
                                               checked={filtersArray.findReturn}
                                               onChange={(e) => handleCheckboxFindReturnChange(e)}/>
                                        <span className="filter-popup__slider"></span>
                                    </label>
                                </div>
                                :
                                <></>
                        }

                        <div className="filter-popup__date filter-popup__category-container">
                            {/* <div className="filter-popup__show-filter-button filter-popup__category-button"> */}
                            {/*  */}
                            {/* </div> */}
                            <div
                                className="filter-popup__date-input-containter filter-popup__category-input filter-popup__date-input-containter_opened">
                                {/* Дата */}
                                {/*<span className="filter-popup__label">Когда?</span>*/}

                                <div className="filter-popup__date-checkbox-container">
                                    <div className="filter-popup__row_date filter-popup__row_date_first">
                                        <div
                                            className="filter-popup__check-button-container filter-popup_check-next-day">
                                            <input type="radio" name="date" id="next" value={afterTomorrowDate}
                                                   className="filter-popup__check-button"
                                                   onChange={handleDateCheckboxClick}
                                                   checked={filtersArray.dateChoose === 'next' ? true : false}/>
                                            <label htmlFor="next" className="filter-popup__check-button-label">Сегодня -
                                                завтра - послезавтра</label>
                                        </div>
                                    </div>

                                    <div className="filter-popup__row_date">
                                        <div className="filter-popup__check-button-container filter-popup_check-today">
                                            <input type="radio" name="date" id="today" value={todayDate}
                                                   className="filter-popup__check-button"
                                                   onChange={handleDateCheckboxClick}
                                                   checked={filtersArray.dateChoose === 'today' ? true : false}/>
                                            <label htmlFor="today"
                                                   className="filter-popup__check-button-label">Сегодня</label>
                                        </div>
                                        <div
                                            className="filter-popup__check-button-container filter-popup_check-tomorrow">
                                            <input type="radio" name="date" id="tomorrow" value={tomorrowDate}
                                                   className="filter-popup__check-button"
                                                   onChange={handleDateCheckboxClick}
                                                   checked={filtersArray.dateChoose === 'tomorrow' ? true : false}/>
                                            <label htmlFor="tomorrow" className="filter-popup__check-button-label">Сегодня
                                                - завтра</label>
                                        </div>
                                    </div>

                                    <div className="filter-popup__row_date">
                                        <div
                                            className="filter-popup__check-button-container filter-popup_check-next-day">
                                            <input type="radio" name="date" id="from-today" value={afterTomorrowDate}
                                                   className="filter-popup__check-button"
                                                   onChange={handleDateCheckboxClick}
                                                   checked={filtersArray.dateChoose === 'from-today' ? true : false}/>
                                            <label htmlFor="from-today" className="filter-popup__check-button-label">С
                                                этого дня</label>
                                        </div>
                                        <div
                                            className="filter-popup__check-button-container filter-popup_check-next-day">
                                            <input type="radio" name="date" id="from-tomorrow" value={afterTomorrowDate}
                                                   className="filter-popup__check-button"
                                                   onChange={handleDateCheckboxClick}
                                                   checked={filtersArray.dateChoose === 'from-tomorrow' ? true : false}/>
                                            <label htmlFor="from-tomorrow" className="filter-popup__check-button-label">Начиная
                                                с завтра</label>
                                        </div>
                                    </div>
                                </div>

                                {/*<span className="filter-popup__label">Или укажите конкретные даты</span>*/}

                                {/*<div className="filter-popup__date-inputs">*/}
                                {/*    <input type="date" className="filter-popup__date-input filter-popup__num-input" value={filtersArray.dates[0] ? new Date(filtersArray.dates[0]).toISOString().split('T')[0] : ''} name="dates" id="from" onChange={handleInputChange} />*/}
                                {/*    <img src={separatorLine} alt="--" className="filter-popup__separator" />*/}
                                {/*    <input type="date" className="filter-popup__date-input filter-popup__num-input" value={filtersArray.dates[1] ? new Date(filtersArray.dates[1]).toISOString().split('T')[0] : ''} name="dates" id="to" onChange={handleInputChange} />*/}
                                {/*</div>*/}
                            </div>
                        </div>


                        <div className="filter-popup__submit-button-container">
                            <button className="filter-popup__submit-button" onClick={() => handleSubmit()}>Искать груз
                            </button>
                            <button className="filter-popup__reset-button" onClick={() => handleReset()}>Сбросить
                                фильтр
                            </button>
                        </div>

                    </div>
                    :
                    <></>
            }
        </div>
    )
}

export default FilterPopup;